import styled from 'vue-styled-components'
const WrapperProps = {
  position: {},
  isActiveWidget: false,
}

const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 6;
&::after {
position: absolute;
top: 0;
  content: '';
  width: 100%;
  height: 100%;
  border: ${({isActiveWidget}) => isActiveWidget ? '1px solid #A9A9A9' : '4px solid #12A9FF'};
  z-index: 5;
}
.add-widget {
  position: absolute;
  pointer-events: auto;
  color:  #12A9FF;
  background-color: white;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.lbl-name {
  z-index: 1;
  bottom: 100%;
}

&.top {
  .cell-tool {
    z-index: 1;
    bottom: 100%;
  }
}
&.bottom {
  .cell-tool {
    z-index: 1;
    // top: 100%;
    bottom: 100%;
  }
}

`

const LegendProps = {
  indexCell: 0,
  isOverlapSection: false,
}

const Legend = styled('div', LegendProps)`
pointer-events: auto;
position: absolute;
width: fit-content;
left: ${({ indexCell, isOverlapSection }) => indexCell == 0 ? isOverlapSection ? '126px' : '54px' : '0px'};
color: white;
background-color: #12A9FF;
border: 1px solid #12A9FF;
padding: 2px 12px 0px;
font-family: 'Roboto';
font-size: 12px;
line-height: 12px;

&.disabled {
  background-color: #A9A9A9;
  border: 1px solid #A9A9A9;
  color: white;
}
&.lbl-hover:hover {
  background-color: #F4FCFF;
  border: 1px solid #12A9FF;
  color: #12A9FF;
  cursor: pointer;
}

button.dropdown-toggle {
  padding: 0px 10px;
  background: transparent !important;
  border: none !important;
  &.btn-secondary:not(:disabled):not(.disabled):focus {
    &:active {
      background: transparent !important;
      border: none !important;
    }
    &:focus {
      box-shadow: none;
    }
  }
}

ul.dropdown-menu {
  background-color: transparent;
  border: none;
  li {
    background-color: #ADDFFC;
    width: fit-content;
    a {
      color: #0B77B5;
      padding: 2px 6px;
    }
    &:not(:first-child) {
      margin-top: 10px;
    }
}
`
const CellTool = styled.div`
 pointer-events: auto;
position: absolute;
width: fit-content;
padding: 2px;
height: 16px;
right: 0;
color: white;
background-color: #12A9FF;
border: 1px solid #12A9FF;
border-radius: 4px 4px 0px 0px;

&.disabled {
  background-color: #A9A9A9;
  border-color: #A9A9A9;
  > div {
    &:hover {
      background-color: unset
    }
  }
}
`
const CellAction = styled.div`
display: flex;
padding: 0px 2px;
height: 100%;
//font-size: 1.2em;
&:hover {
  background-color: #0B77B5;
  border-radius: 2px;
  cursor: pointer;
}
`

export {
  Wrapper,
  Legend,
  CellTool,
  CellAction,
}